export default __webpack_public_path__ + "static/media/screen_google_drive_02.952607ae.png";